/**
 * DropdownMenuItems.jsx
 * Created by michaelbray on 6/4/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../sharedComponents/icons/Icons';

export default function DropdownMenuItems({
    commercialAccount,
    signOut,
    isGuest,
    hideBottomSignOut = false,
}) {
    // Check if commercial user
    let commercialMenuItem = null;
    if (commercialAccount) {
        commercialMenuItem = (
            <li className="rec-select-option">
                <a
                    className="rec-select-option-button"
                    title="Commercial Account"
                    aria-label="Commercial Account"
                    href="/account/facilities">
                    Commercial Account
                    <span className="nav-mobile-menu-row-icon">
                        <Icons.IconOffer />
                    </span>
                </a>
            </li>
        );
    }

    return (
        <ul>
            {!isGuest && (
                <React.Fragment>
                    <li className="rec-select-option">
                        <a
                            className="rec-select-option-button"
                            title="My Account"
                            href="/account/profile"
                            aria-label="My Account">
                            My Account
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconAccountCircle alt="My Account" />
                            </span>
                        </a>
                    </li>
                    <li className="rec-select-option">
                        <a
                            className="rec-select-option-button"
                            title="My Reservations"
                            href="/account/reservations"
                            aria-label="My Reservations">
                            My Reservations
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconCalendarAvailable alt="My Reservations" />
                            </span>
                        </a>
                    </li>
                    <li className="rec-select-option">
                        <a
                            href="/account/passes"
                            className="rec-select-option-button"
                            title="My Passes"
                            aria-label="My Passes">
                            My Passes
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconCard alt="My Passes" />
                            </span>
                        </a>
                    </li>
                    <li className="rec-select-option">
                        <a
                            href="/account/favorites"
                            className="rec-select-option-button"
                            title="My Favorites"
                            aria-label="My Favorites">
                            My Favorites
                            <span className="nav-mobile-menu-row-icon">
                                <Icons.IconFavorite alt="My Favorites" />
                            </span>
                        </a>
                    </li>
                </React.Fragment>
            )}
            <li className="rec-select-option rec-menu-cart">
                <a
                    className="rec-select-option-button"
                    title="My Cart"
                    aria-label="My Cart"
                    href="/cart"
                    type="button">
                    My Cart
                    <span className="nav-mobile-menu-row-icon">
                        <Icons.IconCart alt="My Cart" />
                    </span>
                </a>
            </li>
            {commercialMenuItem}
            {!hideBottomSignOut && (
                <li className="rec-select-option">
                    <button
                        className="rec-close-dropdown-button"
                        onClick={signOut}
                        aria-label="Sign Out"
                        type="button">
                        Sign Out
                    </button>
                </li>
            )}
        </ul>
    );
}

DropdownMenuItems.propTypes = {
    commercialAccount: PropTypes.bool,
    signOut: PropTypes.func,
    isGuest: PropTypes.bool,
    hideBottomSignOut: PropTypes.bool,
};
